export default "__VITE_ASSET__Clu$5PhG__"